<template>
    <div>
        <vs-row class="cardGeneral">
            <vs-col class="cardReportes" vs-type="flex" vs-justify="center" vs-align="center" w="12">
                <h4 class="p-2">Reporte Académico</h4>
                <vs-row class="mt-4">
                    <vs-col sm="12" lg="3">
                        <form autocomplete="off">
                            <label for="institucion" class="labelInput">
                                Institución
                            </label>
                            <vs-select filter class="aqui pt-0" id="institucion" placeholder="Seleccionar Institución" :key="institucionId" v-model="institucion" :disabled="!instituciones.length">
                                <template #message-danger v-if="errorFields.includes('institucion')">
                                    Requerido
                                </template>
                                <template v-if="instituciones.length" autocomplete="off">
                                    <vs-option v-for="option in instituciones" :key="option.id"  :label="option.text" :value="option.id">
                                        {{option.text}}
                                    </vs-option>
                                </template>
                                <template v-else>
                                    <vs-option label="No hay datos" v-text="'No hay datos'" :value="0">
                                    </vs-option>
                                </template>
                            </vs-select>
                        </form>
                    </vs-col>
                    <vs-col sm="12" lg="3">
                        <form autocomplete="off">
                            <label for="cicloEscolar" class="labelInput">
                                Ciclo Escolar
                            </label>
                            <vs-select filter :loading="loadingCiclo" class="aqui pt-0" id="cicloEscolar" placeholder="Seleccionar Ciclo Escolar" :key="cicloId" v-model="cicloEscolar" :disabled="!ciclosEscolares.length">
                                <template #message-danger v-if="errorFields.includes('cicloEscolar')">
                                    Requerido
                                </template>
                                <template v-if="ciclosEscolares.length" autocomplete="off">
                                    <vs-option v-for="option in ciclosEscolares" :key="option.id"  :label="option.text" :value="option.id">
                                        {{option.text}}
                                    </vs-option>
                                </template>
                                <template v-else>
                                    <vs-option label="No hay datos" v-text="'No hay datos'" :value="0">
                                    </vs-option>
                                </template>
                            </vs-select>
                        </form>
                    </vs-col> 
                    <vs-col sm="12" lg="3">
                        <label for="programa" class="pl-3 mr-1 labelInput">Programa</label>
                        <form autocomplete="off">
                            <vs-select :loading="loadingPrograma" id="programa" filter placeholder="Programa" v-model="programa"  :disabled="!programas.length" class="pt-0" :key="programasId">
                                <template #message-danger v-if="errorFields.includes('programa')">
                                    Requerido
                                </template>
                                <template v-if="programas.length">
                                    <vs-option v-for="option in programas" :key="option.id"  :label="option.text" :value="option.id">
                                        {{option.text}}
                                    </vs-option>
                                </template>
                                <template v-else>
                                    <vs-option label="No hay datos" v-text="'No hay datos'" :value="0">
                                    </vs-option>
                                </template>
                            </vs-select>
                        </form>
                    </vs-col>
                    <vs-col sm="12" lg="3">
                        <label for="periodos" class="pl-3 mr-1 labelInput">Periodo de entrada</label>
                        <form autocomplete="off">
                            <div>
                                <vs-select :loading="loadingPeriodo" id="periodos" filter placeholder="Periodo" v-model="periodo"  :disabled="periodo_calculado !== '' || !periodos.length" class="pt-0" :key="periodosId">
                                    <template #message-danger v-if="errorFields.includes('periodo')">
                                        Requerido
                                    </template>
                                    <template v-if="periodos.length">
                                        <vs-option v-for="option in periodos" :key="option.id"  :label="option.periodo" :value="option.configuracion_evaluacion_id">
                                            {{option.periodo}}
                                        </vs-option>
                                    </template>
                                    <template v-else>
                                        <vs-option label="No hay datos" v-text="'No hay datos'" :value="0">
                                        </vs-option>
                                    </template>
                                </vs-select>
                            </div>
                            <div v-if="periodo !== ''" @click="periodo = ''" class="tache">
                                <i class="far fa-times-circle"></i>
                            </div>
                        </form>
                    </vs-col>
                    <vs-col sm="12" lg="3">
                        <label for="periodos" class="pl-3 mr-1 labelInput">Periodos calculados</label>
                        <form autocomplete="off">
                            <div>
                                <vs-select :loading="loadingPeriodoCalculado" id="periodos" filter placeholder="Periodos calculados" v-model="periodo_calculado" :disabled="periodo !== '' || !periodos_calculados.length"  class="pt-0" :key="periodosCalculadosId">
                                    <template #message-danger v-if="errorFields.includes('periodo_calculado')">
                                        Requerido
                                    </template>
                                    <vs-option-group v-for="option in periodos_calculados" :key="option.text">
                                        <div slot="title">
                                            {{option.text}}
                                        </div>
                                        <vs-option v-for="opciones in option.opciones" :key="opciones.id"  :label="opciones.text" :value="opciones.id">
                                            <p>{{opciones.text}}</p>
                                            <p><small>{{opciones.ciudad}}</small></p>
                                        </vs-option>
                                    </vs-option-group>
                                </vs-select>
                            </div>
                            <div v-if="periodo_calculado !== ''" @click="periodo_calculado = ''" class="tache">
                                <i class="far fa-times-circle"></i>
                            </div>
                        </form>
                    </vs-col>
                    <vs-col sm="12" lg="3">
                        <label for="grado" class="pl-3 mr-1 labelInput">Grado</label>
                        <form autocomplete="off">
                            <div style="position: relative">
                                <vs-select :loading="loadingGrado" id="grado" filter placeholder="Grado" v-model="grado"  :disabled="grupoAdmin != '' || grupo != '' || !grados.length" class="pt-0" :key="gradosId">
                                    <template #message-danger v-if="errorFields.includes('grado')">
                                        Requerido
                                    </template>
                                    <template v-if="grados.length">
                                        <vs-option v-for="option in grados" :key="option.id"  :label="option.text" :value="option.id">
                                            {{option.text}}
                                        </vs-option>
                                    </template>
                                    <template v-else>
                                        <vs-option label="No hay datos" v-text="'No hay datos'" :value="0">
                                        </vs-option>
                                    </template>
                                </vs-select>
                            </div>
                            <div v-if="grado !== ''" @click="grado = ''" class="tache">
                                <i class="far fa-times-circle"></i>
                            </div>
                        </form>
                    </vs-col>
                    <vs-col sm="12" lg="3">
                        <label for="grupo-academico" class="pl-3 mr-1 labelInput">Grupo Académico</label>
                        <form autocomplete="off">
                            <div style="position: relative">
                                <vs-select :disabled="grupoAdmin != '' || grado != '' || !grupos.length" :loading="loadingGrupo" id="grupo-academico" filter placeholder="Grupo Académico" v-model="grupo" class="pt-0" :key="gruposId">
                                    <template #message-danger v-if="errorFields.includes('grupo')">
                                        Requerido
                                    </template>
                                    <template v-if="grupos.length">
                                        <vs-option v-for="option in grupos" :key="option.id"  :label="option.nombre" :value="option.bloque_academico_id">
                                            {{option.nombre}}
                                        </vs-option>
                                    </template>
                                    <template v-else>
                                        <vs-option label="No hay datos" v-text="'No hay datos'" :value="0">
                                        </vs-option>
                                    </template>
                                </vs-select>
                            </div>
                            <div v-if="grupo !== ''" @click="grupo = ''" class="tache">
                                <i class="far fa-times-circle"></i>
                            </div>
                        </form>
                    </vs-col>
                    <vs-col sm="12" lg="3">
                        <form autocomplete="off">
                            <label for="grupo" class="labelInput">
                                Grupo Administrativo
                            </label>
                            <div style="position: relative">
                                <vs-select 
                                    :disabled="grupo != '' || grado != '' || !gruposAdmin.length"
                                    :loading="loadingGrupoAdmin"
                                    filter
                                    class="pt-0"
                                    id="grupo"
                                    placeholder="Seleccionar grupo administrativo"
                                    :key="gruposAdminId"
                                    v-model="grupoAdmin">
                                    <template #message-danger v-if="errorFields.includes('grupoAdmin')">
                                        Requerido
                                    </template>
                                    <template v-if="gruposAdmin.length">
                                        <vs-option v-for="option in gruposAdmin" :key="option.id"  :label="option.text" :value="option.id">
                                            {{option.text}}
                                        </vs-option>
                                    </template>
                                    <template v-else>
                                        <vs-option label="No hay datos" v-text="'No hay datos'" :value="0">
                                        </vs-option>
                                    </template>
                                </vs-select>
                            </div>
                            <div v-if="grupoAdmin !== ''" @click="grupoAdmin = ''" class="tache">
                                <i class="far fa-times-circle"></i>
                            </div>
                        </form>
                    </vs-col>
                    <vs-col sm="12" lg="3">
                        <label for="rubro" class="pl-3 mr-1 labelInput">Rubro</label>
                        <form autocomplete="off">
                            <vs-select id="rubro" filter placeholder="Rubro" v-model="rubro" class="pt-0" :key="rubroId">
                                <template #message-danger v-if="errorFields.includes('rubro')">
                                    Requerido
                                </template>
                                <template>
                                    <vs-option label="Calificaciones" value="calificacion">
                                        Calificaciones
                                    </vs-option>
                                    <vs-option label="Faltas" value="faltas">
                                        Faltas
                                    </vs-option>
                                    <vs-option v-show="periodo != ''" label="Retardos" value="retardos">
                                        Retardos
                                    </vs-option>
                                    <vs-option v-show="periodo != ''" label="Conducta" value="conducta">
                                        Conducta
                                    </vs-option>
                                    <vs-option v-show="periodo != ''" label="Tareas no hechas" value="tareas_no_hechas">
                                        Tareas no hechas
                                    </vs-option>
                                    <vs-option v-show="periodo != ''" label="Observaciones" value="observaciones">
                                        Observaciones
                                    </vs-option>
                                </template>
                            </vs-select>
                        </form>
                    </vs-col>
                </vs-row>
                <vs-row>
                    <vs-col>
                        <vs-button
                            class="ml-auto"
                            @click="getInfoCalificaciones()"
                        >
                            <i class="fas fa-search mr-2"></i>Buscar
                        </vs-button>
                    </vs-col>
                </vs-row>
                <tabla-calificaciones :cicloEscolar="cicloEscolar" :institucion="institucion" :programa="programa" :periodo="periodo" :grupo="grupo" :rubro="tipoRubro" :grupoAdmin="grupoAdmin" :grado="grado" :periodo_calculado="periodo_calculado" :ejecutar="ejecutar"></tabla-calificaciones>
            </vs-col>
        </vs-row>
    </div>
</template>

<script>
import reportes from '../../../../api/requests/reportes.js'
import catalogos from '../../../../api/requests/catalogos.js'
import TablaCalificaciones from './tabla-calificaciones.vue'
export default {
    data(){
        return{
            institucion: '',
            instituciones: [],
            institucionId: (new Date()).getTime(),
            cicloEscolar: '',
            ciclosEscolares: [],
            cicloId: (new Date()).getTime(),
            loadingCiclo: false,
            programa: '',
            programas: [],
            programasId:(new Date()).getTime(),
            loadingPrograma: false,
            grado: '',
            grados: [],
            gradosId:(new Date()).getTime(),
            loadingGrado: false,
            periodo: '',
            periodos: [],
            periodosId:(new Date()).getTime(),
            loadingPeriodo: false,
            periodo_calculado: '',
            periodos_calculados: [],
            periodosCalculadosId:(new Date()).getTime(),
            loadingPeriodoCalculado: false,
            grupo: '',
            grupos: [],
            gruposId:(new Date()).getTime(),
            loadingGrupo: false,
            grupoAdmin: '',
            gruposAdmin: [],
            gruposAdminId:(new Date()).getTime(),
            loadingGrupoAdmin: false,
            rubro: '',
            rubroId:(new Date()).getTime(),
            ejecutar: 0,
            errorFields: [],
            tipoRubro: '',
            tache: false
        }
    },
    components:{
        TablaCalificaciones
    },
    created(){
        this.getInstituciones()
    },
    methods: {
        async getInstituciones(){
            try {
                const response = await reportes.getInstitucion()
                this.instituciones = response.data
                this.institucionId = (new Date()).getTime()
            }
            catch{

            }
        },
        async getCicloEscolar() {
            this.loadingCiclo = true
            const { data: response } = await reportes.getCiclosEscolares(this.institucion)
            this.ciclosEscolares = response
            this.cicloId = (new Date()).getTime()
            this.loadingCiclo = false
        },
        async getPrograma(){
            if (this.cicloEscolar) {
                try {
                    this.loadingPrograma = true
                    const {data: response} = await catalogos.getProgramas(this.institucion)
                    this.programas = response
                    this.programasId = (new Date()).getTime()
                    this.loadingPrograma = false
                } catch (error) {
                    
                }
            }
        },
        async getGradoAcademico(){
            if (this.programa) {
                try {
                    this.loadingGrado = true
                    const {data: response} = await reportes.getGradoAcademico(this.programa)
                    this.grados = response
                    this.gradosId = (new Date()).getTime()
                    this.loadingGrado = false
                } catch (error) {
                    
                }
            }
        },
        async getPeriodoCalificaciones(){
            if (this.programa) {
                try {
                    this.loadingPeriodo = true
                    const params = {
                        institucion_id: this.institucion,
                        ciclo_escolar_id: this.cicloEscolar,
                        programa_id: this.programa
                    }
                    const {data: response} = await reportes.getPeriodoCalificaciones(params)
                    this.periodos = response
                    this.periodosId = (new Date()).getTime()
                    this.loadingPeriodo = false
                } catch (error) {
                    
                }
            }
        },
        async getPeriodoCalculados(){
            if (this.cicloEscolar) {
                try {
                    this.loadingPeriodoCalculado = true
                    const params = {
                        institucion_id: this.institucion,
                        ciclo_escolar_id: this.cicloEscolar,
                    }
                    const {data: response} = await reportes.getPeriodoCalculados(params)
                    this.periodos_calculados = response
                    this.periodosCalculadosId = (new Date()).getTime()
                    this.loadingPeriodoCalculado = false
                } catch (error) {
                    
                }
            }
        },
        getSelectRubros(){
            this.rubro = ''
        },
        async getGrupoAcademico(){
            if (this.programa) {
                try {
                    this.loadingGrupo = true
                    const params = {
                        institucion_id: this.institucion,
                        ciclo_escolar_id: this.cicloEscolar,
                        programa_id: this.programa
                    }
                    const {data: response} = await reportes.getGrupoAcademico(params)
                    this.grupos = response
                    this.gruposId = (new Date()).getTime()
                    this.loadingGrupo = false
                } catch (error) {
                    
                }
            }
        },
        async getGrupoAdministrativo(){
            if (this.programa) {
                try {
                    this.loadingGrupoAdmin = true
                    const params = {
                        ciclo_escolar_id: this.cicloEscolar,
                        programa_id: this.programa
                    }
                    const {data: response} = await reportes.getGrupo(this.institucion, params)
                    this.gruposAdmin = response
                    this.gruposAdminId = (new Date()).getTime()
                    this.loadingGrupoAdmin = false
                } catch (error) {
                    
                }
            }
        },
        checkByType (type, val) {
            switch (type) {
                case 'string':
                    if (val && val.constructor.name === 'String' && val.trim()) {
                        return true
                    }
                case 'number':
                    if (val && val.constructor.name === 'Number' && val > 0) {
                        return true
                    } 
                case 'array':
                    if (Array.isArray(val) && val.length){
                        return true
                    }
            }
            return false
        },
        sanityForm () {
            this.errorFields = []
            if (!this.checkByType ('number', this.cicloEscolar)) {
                this.errorFields.push('cicloEscolar')
            }
            if (!this.checkByType ('number', parseInt(this.institucion))) {
                this.errorFields.push('institucion')
            }
            if (!this.checkByType ('number', parseInt(this.programa))) {
                this.errorFields.push('programa')
            }
            if(this.grupoAdmin == '' && this.grado == ''){
                if (!this.checkByType ('number', parseInt(this.grupo))) {
                    this.errorFields.push('grupo')
                }
            }
            if(this.grupo == '' && this.grado == ''){
                if (!this.checkByType ('number', parseInt(this.grupoAdmin))) {
                    this.errorFields.push('grupoAdmin')
                }
            }
            if(this.grupo == '' && this.grupoAdmin == ''){
                if (!this.checkByType ('number', parseInt(this.grado))) {
                    this.errorFields.push('grado')
                }
            }
            if(this.periodo_calculado == ''){
                if (!this.checkByType ('number', parseInt(this.periodo))) {
                    this.errorFields.push('periodo')
                }
            }
            if(this.periodo == ''){
                if (!this.periodo_calculado) {
                    this.errorFields.push('periodo_calculado')
                }
            }
            if (!this.rubro) {
                this.errorFields.push('rubro')
            }
            if (!this.errorFields.length){
                return this.ejecutar += 1
            } else {
                return null
            }
        },
        getInfoCalificaciones(){
            this.sanityForm()
            this.tipoRubro = this.rubro
        }
    },
    watch:{
        institucion(){
            this.cicloEscolar = ''
            this.programa = ''
            this.grupo = ''
            this.periodo = ''
            this.getCicloEscolar()
        },
        cicloEscolar(){
            this.getPrograma()
            this.getPeriodoCalculados()
        },
        programa(){
            this.grupo = ''
            this.periodo = ''
            this.getGrupoAdministrativo()
            this.getGrupoAcademico()
            this.getPeriodoCalificaciones()
            this.getGradoAcademico()
        },
    }
}
</script>

<style lang="scss" scoped>
    .cardReportes{
        width: 100%;
        background-color:white;
        justify-content: space-between;
        @media only screen and (max-width: 768px) {
            margin: 16px;
        }
        @media only screen and (min-width: 768px) {
            margin: 16px 30px;
        }
        border-radius: 3px;
        padding: 10px
    }
    .cardGeneral{
        @media only screen and (max-width: 768px) {
            width: 85%;
        }
        @media only screen and (min-width: 768px) {
            width: 95%;
        }
    }
    .tache{
        position: absolute;
        cursor: pointer;
        top: 35px;
        @media only screen and (max-width: 768px) {
            left: calc(95% - 4em);
        }
        @media only screen and (min-width: 768px) {
            left: calc(98% - 4em);
        }

    }
</style>
